import { WatchDemoButton } from 'components/WatchDemoButton'
import { Marketing } from 'designsystem/Text'

interface FeatureHeroProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: JSX.Element
  headline: string | JSX.Element
  subline?: string
  label?: string
  withinSection?: boolean
  showDemoVideoModal?: () => void
  theme: 'blue' | 'magenta' | 'red'
}

export const FeatureHero = ({
  icon,
  headline,
  subline,
  label,
  theme,
  showDemoVideoModal,
  className,
  children,
  ...props
}: FeatureHeroProps): JSX.Element => {
  return (
    <div className={`text-left sm:text-center ${className || ''}`} {...props}>
      {icon && <div className='w-14 h-auto sm:w-24 sm:mx-auto'>{icon}</div>}

      {label && (
        <p className={`label text-neutral-60 ${icon ? 'spacer-lg' : ''}`}>
          {label}
        </p>
      )}

      <Marketing.H1
        className={`max-w-2xl mx-auto ${
          icon && !label ? 'spacer-lg' : label ? 'spacer-4xs' : ''
        }`}
      >
        {headline}
      </Marketing.H1>

      {subline && (
        <Marketing.SubHeadline className='spacer-3xs max-w-xl'>
          {subline}
        </Marketing.SubHeadline>
      )}
      {showDemoVideoModal && (
        <WatchDemoButton
          color={theme}
          className='spacer-lg'
          onClick={showDemoVideoModal}
        >
          Watch the demo
        </WatchDemoButton>
      )}
      {children}
    </div>
  )
}
